class AnimateSticky extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);

        window.addEventListener('scroll', this.onScrollHandler, false);
        this.onScrollHandler();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.getOffsetTop(this)) {
            window.requestAnimationFrame(this.reveal.bind(this));
        } else {
            window.requestAnimationFrame(this.reset.bind(this));
        }
    }

    reveal() {
        this.setAttribute('animate', '');
    }

    reset() {
        this.removeAttribute('animate');
    }

    getOffsetTop(element) {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }
}
customElements.define('animate-sticky', AnimateSticky);
